import { z } from 'zod'

const DEFAULT_API_TIMEOUT = 10000

const envSchema = z.object({
  DEV: z.boolean().default(true),
  VITE_API_URL: z.url().default('http://localhost:8080'),
  VITE_API_TIMEOUT: z.coerce.number().default(DEFAULT_API_TIMEOUT),
  VITE_GOOGLE_CLIENT_ID: z.string().optional().default(''),
  VITE_MAP_PROVIDER: z.enum(['mapbox', 'google']).optional().default('mapbox'),
  VITE_MAPBOX_TOKEN: z.string().optional().default(''),
  VITE_GOOGLE_MAPS_API_KEY: z.string().optional().default(''),
  VITE_GOOGLE_MAPS_MAP_ID: z.string().optional().default(''),
  VITE_SENTRY_DSN: z.string().optional(),
})

type Env = z.infer<typeof envSchema>

function validateEnv(): Env {
  const parsed = envSchema.safeParse(import.meta.env)

  if (!parsed.success) {
    console.error('Invalid environment variables:', parsed.error.issues)
    throw new Error('Invalid environment variables')
  }

  return parsed.data
}

export const env = validateEnv()
